module.exports = __webpack_public_path__ + "img/download-btn.933e5061.png";